import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack, useColorModeValue } from '@chakra-ui/react'
import { GetDashboardOrganizationQuery } from '../../../../api/queries/organization/OrganizationQueries'
import { history } from '../../../../ApplicationRouter'
import { OrganizationForm } from '../../../../components/secure/dashboard/organization/OrganizationForm'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

export const EditOrganization = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  const { data, error, isError, isLoading } = useQuery(['organization', id], () => GetDashboardOrganizationQuery(id), { enabled: !!id });

  return (
    <AutoWidthCenter bg={useColorModeValue("bgTertiaryWhite", "bgPrimaryBlack")}>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">{t('Organization.Edit')}</Heading>
          <Button onClick={() => history.back()}>{t('Return')}</Button>
        </HStack>
        <Divider />
        {data &&
          <OrganizationForm organization={data} />
        }
      </Box>
    </AutoWidthCenter >
  )
}